import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: 20,
  },
  cleanFiltersButton: {
    color: '#971414 !important',
    border: '#971414 solid 1px !important',
    marginTop: 15,
  },
  activateFiltersButton: {
    marginTop: 15,
    marginRight: 15,
  },
}))
